import styled from 'styled-components';

export const MainContainer = styled.div`
  .ant-table-content .ant-table-tbody .ant-table-expanded-row td > div > div {
    display: block;
  }
  tr.ant-table-expanded-row > td {
    padding: 0;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;
